export function optionallyTransformed<TInput, TOutput>(transform: (value: TInput) => TOutput): (value: TInput | undefined) => TOutput | undefined {
  return value => value === undefined ? undefined : transform(value);
}
